"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoTabContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ItemsList_1 = require("../ItemsList");
const bridge_1 = require("@completeanatomy/bridge");
const hooks_1 = require("../../hooks");
const noop_1 = __importDefault(require("lodash/noop"));
const VideoTabContent = ({ type, onResize = noop_1.default, }) => {
    const { items = [] } = (0, hooks_1.useTabContent)(type) || {};
    const bridge = (0, bridge_1.useBridge)();
    // const { navigate } = useNavigate();
    const handleClick = (0, react_1.useCallback)((index) => {
        if (!items) {
            return;
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxListItem({
            type,
            index,
            identifier: items[index].identifier,
        });
        // navigate(`mode/video/${item.identifier}`);
    }, [bridge, type, items]);
    return ((0, jsx_runtime_1.jsx)(ItemsList_1.ItemsList, { onResize: onResize, onClick: handleClick, withVideoPlaceholder: true, itemSize: 76, "data-e2e": 'ItemsList', children: items || [] }));
};
exports.VideoTabContent = VideoTabContent;
